export const airportsOrder = [
	'warszawa-okecie-chopin', // Chopina
	'krakow-balice', // Kraków
	'gdansk-lotnisko-lecha-walesy', // Gdańsk
	'wroclaw-strachowice-lotnisko', // Wrocław
	'poznan-lawica-lotnisko', // Poznań
	'warszawa-modlin', // Modlin
	'katowice-pyrzowice-lotnisko', // Katowice
	'bydgoszcz-szwederowo-lotnisko', // Bydgoszcz
	'lodz-lotnisko-lublinek', // Łódź
	'rzeszow-lotnisko', // Rzeszów
	'szczecin-lotnisko-goleniow', // Szczecin
	'lublin-lotnisko-swidnik', // Lublin
	'zielona-gora-lotnisko', // Zielona Góra
	'olsztyn-szymany-lotnisko', // Olsztyn
	'warszawa-radom-lotnisko', // Warszawa-Radom
]

export const branchesOrder = [
	'warszawa-centralna', // Jerozolimskie
	'warszawa-ul-cybernetyki-5', // Cybernetyki
	'krakow', // Kraków
	'gdansk', // Gdańsk
	'wroclaw', // Wrocław
	'poznan', // Poznań
	'katowice', // Katowice
	'bydgoszcz', // Bydgoszcz
	'lodz', // Łódź
	'rzeszow', // Rzeszów
	'szczecin', // Szczecin
	'kielce', // Kielce
	'lublin', // Lublin
	'zielona-gora', // Zielona Góra
	'olsztyn', // Olsztyn
	'bialystok', // Białystok
	'czestochowa', // Częstochowa
	'torun', // Toruń
]
